import { useField, useFormikContext } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { Grid, GridProps, Typography } from '@material-ui/core';

import InputFile from '../forms/InputFile';

const StyledGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  .multiple-files-container {
    padding: 0 20px;
    button {
      margin-right: 10px;
    }
  }
`;

export interface InlineFileValue {
  url?: string;
  signedUrl?: string;
  name?: string;
  size?: number;
}

const InlineFile: React.FC<{
  multiple?: boolean;
  name: string;
  label?: string;
  token?: string;
  uploadPath: string;
  inputType?: string;
  compact?: boolean;
  grid?: GridProps;
  disabled?: boolean;
}> = ({
  multiple,
  label,
  grid,
  token,
  uploadPath,
  inputType,
  compact = false,
  disabled = false,
  ...fieldProps // Note: fieldProps needs to have `name` prop
}) => {
  if (!grid) {
    // default field to expand entire width of form
    grid = { xs: 12 };
  }
  const formik = useFormikContext();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, meta, { setValue, setTouched }] =
    useField<InlineFileValue[]>(fieldProps);
  return (
    <StyledGrid item className='inline-text-field' {...grid}>
      {label && (
        <Typography variant='h5' gutterBottom>
          {label}
        </Typography>
      )}
      <InputFile
        token={token}
        compact={compact}
        disabled={disabled}
        multiple={multiple}
        inputType={inputType}
        uploadPath={uploadPath}
        isLoading={formik.isSubmitting}
        values={field.value}
        setTouched={setTouched}
        onChange={values => {
          setValue(values);
          formik.submitForm();
        }}
      />
    </StyledGrid>
  );
};

export default InlineFile;
